function updateObrivaButtonPrice(block) {
  const price = block.querySelector('.obriva-choice:has(.obriva-choice__radio:checked) .obriva-choice__price')?.textContent?.trim();
  const button = block.querySelector('button[name="add"]');
  const label = block.dataset.obrivaAddLabel;
  if (!price) return;

  const stickyPrice = block.querySelector('[data-obriva-sticky-price]');
  if (stickyPrice) stickyPrice.textContent = price;
  if (!button || !label) return;

  const textNode = [...button.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
  if (textNode) textNode.textContent = `\n    ${label} | ${price}\n    `;
}

document.addEventListener('change', (event) => {
  const option = event.target;
  if (!(option instanceof HTMLInputElement) || !option.matches('[data-obriva-quantity] input[type="radio"]')) return;

  const block = option.closest('.buy-buttons-block--obriva');
  if (!block) return;
  updateObrivaButtonPrice(block);
  const selector = block?.querySelector('quantity-selector-component');
  if (!selector) return;

  selector.setValue(option.value);
  selector.onQuantityChange();
  selector.updateButtonStates();
});

function updateObrivaStickyVisibility() {
  const footer = document.querySelector('footer');
  const footerInView = footer && footer.getBoundingClientRect().top <= window.innerHeight;
  document.querySelectorAll('.buy-buttons-block--obriva').forEach((block) => {
    const sticky = block.querySelector('[data-obriva-sticky-atc]');
    const buyButton = block.querySelector('button[name="add"]');
    if (sticky && buyButton) sticky.hidden = buyButton.getBoundingClientRect().bottom >= 80 || footerInView;
  });
}

if (!window.obrivaStickyAtcReady) {
  window.obrivaStickyAtcReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-obriva-sticky-trigger]') : null;
    if (!trigger) return;
    const offerSelector = document.querySelector('#obriva-tiers');
    const quantitySelector = trigger.closest('.buy-buttons-block--obriva')?.querySelector('[data-obriva-quantity]');
    (offerSelector || quantitySelector)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  window.addEventListener('scroll', updateObrivaStickyVisibility, { passive: true });
  document.addEventListener('scroll', updateObrivaStickyVisibility, { capture: true, passive: true });
  window.addEventListener('resize', updateObrivaStickyVisibility);
  updateObrivaStickyVisibility();
}
